/** Lab CreateCompCtrl body — sport id must be Betfair id, not Postgres game._id. */
export function buildCompetitionCreatePayload(
  game: Record<string, unknown>,
  name: string,
): Record<string, unknown> {
  const sportId = game.id ?? game.betfairId ?? game.eventTypeId
  return {
    name: name.trim(),
    game: sportId,
    betfairId: game.id ?? game.betfairId,
    gameBetfairId: sportId,
  }
}
